// Betalife Stage 1 rollback: remove custom infinite-scroll/loading hooks.
// Keep only the defensive Fastor mobile-menu patch so theme section init cannot be interrupted.
(function patchFastorMobileMenuSection() {
  function applyPatch() {
    if (
      window.Fastor &&
      Fastor.MobileMenuSection &&
      Fastor.MobileMenuSection.prototype &&
      typeof Fastor.MobileMenuSection.prototype._init === 'function' &&
      !Fastor.MobileMenuSection.prototype.__a11yPatched
    ) {
      var originalInit = Fastor.MobileMenuSection.prototype._init;
      Fastor.MobileMenuSection.prototype._init = function () {
        try {
          originalInit.apply(this, arguments);
        } catch (err) {
          console.warn('[accessibility-fixes] Fastor.MobileMenuSection._init failed safely.', err);
        }
      };
      Fastor.MobileMenuSection.prototype.__a11yPatched = true;
      return true;
    }
    return false;
  }

  if (!applyPatch()) {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (applyPatch() || attempts > 50) {
        clearInterval(interval);
      }
    }, 100);
  }
})();
